import ProviderIndex from 'sly/providerIndex';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default ProviderIndex;

export async function getServerSideProps() {
  const { api, store } = createApiClient(apiEndpoints);
  try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    await store.dispatch(api.getProviders.asAction());
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return {
      notFound: true,
    };
  }

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
